var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8187 0C16.2108 0 20.6968 3.87976 21.6373 9C20.6968 14.1202 16.2108 18 10.8187 18C5.42648 18 0.94051 14.1202 0 9C0.94051 3.87976 5.42648 0 10.8187 0ZM10.8187 16C15.0543 16 18.6787 13.052 19.5961 9C18.6787 4.94803 15.0543 2 10.8187 2C6.58296 2 2.95858 4.94803 2.04114 9C2.95858 13.052 6.58296 16 10.8187 16ZM10.8187 13.5C8.33334 13.5 6.31862 11.4853 6.31862 9C6.31862 6.51472 8.33334 4.5 10.8187 4.5C13.3039 4.5 15.3187 6.51472 15.3187 9C15.3187 11.4853 13.3039 13.5 10.8187 13.5ZM10.8187 11.5C12.1994 11.5 13.3187 10.3807 13.3187 9C13.3187 7.6193 12.1994 6.5 10.8187 6.5C9.43796 6.5 8.31862 7.6193 8.31862 9C8.31862 10.3807 9.43796 11.5 10.8187 11.5Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenIcon);
export default __webpack_public_path__ + "static/media/eye_open_icon.436f502e429ef8d118b468eee6785c89.svg";
export { ForwardRef as ReactComponent };